import './newsletter-signup.scss';

import AjaxLoad from './../../components/ajax-load/ajax-load';
import { createElementFromHTML } from '../../utilities/js/helper';

import { WidgetInstance } from 'friendly-challenge';

class NewsletterForm {
    constructor (element, options) {
        const settings = {
            content: element.querySelector('[data-newsletterform="content"]'),
            message: '[data-newsletterform="message"]',
            removeMessageButton: '[data-newsletterform="remove-message"]'
        };

        this.$element = element;
        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        this.setEvents();
        this.initCaptcha();
    }

    initCaptcha () {
        const $captcha = this.$element.querySelector('.frc-captcha');

        if ($captcha && !$captcha.friendlyChallengeWidget) {
            new WidgetInstance($captcha);
        }
    }

    setLoadingState ($form, isLoading) {
        $form.setAttribute('aria-busy', isLoading);
        $form.querySelectorAll('[type="submit"]').forEach($button => {
            $button.disabled = isLoading;
        });
    }

    setEvents () {
        this.$element.addEventListener('submit', (e) => {
            this.submitForm();
            e.preventDefault();
        });

        this.$element.addEventListener('click', (e) => {
            const $retryButton = e.target.closest('[data-newsletterform="retry"]');

            if ($retryButton) {
                this.retry($retryButton);
            }
        });
    }

    submitForm () {
        const $form = this.$element.querySelector('form');

        this.setLoadingState($form, true);

        this.loadContent($form.action, $form.method, new FormData($form), () => {
            this.setLoadingState($form, false);
        });
    }

    retry ($retryButton) {
        $retryButton.disabled = true;

        this.loadContent($retryButton.dataset.newsletterformUrl, 'GET', null, () => {
            $retryButton.disabled = false;
        }, () => {
            this.$element.querySelector('input[type="email"]')?.focus();
        });
    }

    loadContent (url, method, data, onError, onLoaded) {
        new AjaxLoad(url, {
            requestMethod: method,
            requestData: data,
            onError: onError,
            onSuccess: (resultText) => {
                const $result = createElementFromHTML(resultText);

                this.settings.content.innerHTML = '';

                if ($result) {
                    this.settings.content.appendChild($result);
                }

                if (this.$element.querySelectorAll(this.settings.message).length === 1) {
                    this.initMessage();
                }

                this.initCaptcha();

                const contentUpdateEvent = new CustomEvent('content.loaded', {
                    view: window,
                    bubbles: true,
                    cancelable: false,
                    detail: {
                        $context: $result
                    }
                });

                window.dispatchEvent(contentUpdateEvent);

                if (onLoaded) {
                    onLoaded();
                }
            }
        });
    }

    initMessage () {
        const $message = this.$element.querySelector(this.settings.message);
        const $removeMessageButton = $message.querySelector(this.settings.removeMessageButton);

        if ($removeMessageButton && $message) {
            $removeMessageButton.addEventListener('click', () => {
                $message.remove();
                this.$element.querySelector('input[type="email"]')?.focus();
            });
        }
    }
}

export { NewsletterForm };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-newsletterform="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new NewsletterForm($root);
            $rootAPI.initialize();
        });
    }
});
